import { defineMessages } from 'react-intl';

export default defineMessages({
  errorTitlePage: {
    id: 'error_page.title',
  },
  errorDescriptionPage: {
    id: 'error_page.description',
  },
  mailServiceDesk: {
    id: 'restricted_access_page_mail.title',
  },
  telServiceDesk: {
    id: 'restricted_access_page_tel.title',
  },
  refreshTitle: {
    id: 'error_page.refresh_title',
  },
});
